import React from 'react'
import { useAtom } from 'jotai'
import { useLogUserEvent } from '../../../hooks/useLogUserEvent'
import useFetchEntitiesWithCache from '../../../hooks/useFetchEntitiesWithCache'
import { issueFiltersAtom } from '../../../atoms/issueAtom'
import { useFilterIssues } from '../../issues/utils'
import UserEventApi from '../../../api/UserEventApi'
import { IssueMarket } from './IssueMarketOverview'
import Box from '@mui/material/Box'
import RoutedDropdownSelect from '../../components/RoutedDropdownSelect'
import { useQuery } from '../../../hooks/useQuery'
import { Navigate } from 'react-router-dom'
import { OngoingIssuesStats } from './IssueMarketOngoingIssuesStats'
import { endOfQuarter, isBefore, subQuarters } from 'date-fns'
import { getIssueDateToFilter } from '../../../components/utils/categorizeIssues'

const dropdownItems = [
    {
        id: 'overview',
        label: 'Överblick',
    },
    {
        id: 'ongoing-issues-stats',
        label: 'Kommande/pågående FE',
    },
] as const

export const IssueMarketView = () => {
    useLogUserEvent(UserEventApi.EVENT_TYPES.SHOW_STATS_ISSUE_MARKET)
    const { isLoading, result: fetchedIssues } = useFetchEntitiesWithCache('issue')
    const [filters] = useAtom(issueFiltersAtom)
    const filteredIssues = useFilterIssues(fetchedIssues || [], filters)
    const query = useQuery()
    const graphRoutingParam = 'graph'
    const defaultGraph = 'overview'
    const selectedGraph: (typeof dropdownItems)[number]['id'] = query.get(graphRoutingParam) || defaultGraph

    const today = new Date()
    const endOfLastQuarter = endOfQuarter(subQuarters(today, 1))

    const graphSelector = (
        <Box sx={{ marginBottom: 4 }}>
            <RoutedDropdownSelect
                defaultItem={defaultGraph}
                items={dropdownItems}
                label='Välj graf'
                routingParam={graphRoutingParam}
            />
        </Box>
    )

    const issuesExludingCurrentQuarter = filteredIssues.filter((issue) =>
        isBefore(getIssueDateToFilter(issue), endOfLastQuarter),
    )

    if (selectedGraph === 'overview') {
        return <IssueMarket graphSelector={graphSelector} isLoading={isLoading} issues={issuesExludingCurrentQuarter} />
    }

    if (selectedGraph === 'ongoing-issues-stats') {
        return (
            <OngoingIssuesStats
                graphSelector={graphSelector}
                hasTable
                isLoading={isLoading}
                issues={filteredIssues}
                metricType='ongoing-issues'
            />
        )
    }

    return <Navigate to='?graph=overview' replace />
}
